<div class="account-pages mt-5 mb-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card">
                    <div class="card-body p-4">
                        <!-- Logo-->
                        <div class="text-center w-75 m-auto">
                            <a routerLink="/account/login">
                                <img alt="" height="28" src="../../../../assets/images/logo-icon/logo-aivis-dark.png"/>
                            </a>
                            <p class="text-muted mb-4 mt-3">Don't have an account? Create your own account, it takes
                                less than a minute</p>
                        </div>

                        <form (ngSubmit)="onSubmit()" [formGroup]="signupForm" class="needs-validation"
                              name="signupForm">

                            <app-ui-preloader [display]="loading"></app-ui-preloader>

                            <ngb-alert *ngIf="error" [dismissible]="false" type="danger">{{ error }}</ngb-alert>

                            <div class="form-group mb-3">
                                <label>Username<span class="text-danger">*</span></label>

                                <input [ngClass]="{ 'is-invalid': (submitted && f.username.errors) || (!usernameHasUse && f.username.value)}" class="form-control"
                                       formControlName="username"
                                       id="username" placeholder="username"
                                       #checkUsernameDebounce
                                />

                                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                                    <span *ngIf="f.username.errors.required">Please enter user name.</span>
                                    <span *ngIf="f.username.errors.pattern">Please enter user.</span>
                                </div>

                                <div *ngIf="!f.username.errors" class="invalid-feedback">
                                    <span *ngIf="!usernameHasUse">Username already exists</span>
                                </div>
                            </div>

                            <div class="form-group mb-3">
                                <label for="pass1">Password<span class="text-danger">*</span></label>
                                <input [ngClass]="{'is-invalid': submitted && f.password.errors}" class="form-control"
                                       formControlName="password" id="pass1"
                                       placeholder="Password" type="password">
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                    <span *ngIf="f.password.errors.required">Please enter password.</span>
                                    <span *ngIf="f.password.errors.minlength">Password must be at least 6 characters.</span>
                                </div>
                            </div>

                            <div class="form-group mb-3">
                                <label>Confirm Password <span class="text-danger">*</span></label>
                                <input [ngClass]="{'is-invalid': submitted && (f.confirmpwd.errors || f.confirmpwd.value !== f.password.value)}"
                                       class="form-control" formControlName="confirmpwd"
                                       id="passWord2"
                                       placeholder="Password" type="password">
                                <div *ngIf="submitted" class="invalid-feedback">
                                    <span *ngIf="!f.confirmpwd.value">Please enter confirm password.</span>
                                    <span *ngIf="(f.confirmpwd.value !== f.password.value) && f.confirmpwd.value">This value should be the same.</span>
                                </div>
                            </div>

                            <div class="form-group mb-0 text-center">
                                <button class="btn btn-primary btn-block" type="submit">Sign Up</button>
                            </div>
                        </form>
                    </div> <!-- end card-body -->
                </div>
                <!-- end card -->

                <div class="row mt-3">
                    <div class="col-12 text-center">
                        <p class="text-muted">Already have account? <a class="text-muted ml-1"
                                                                       routerLink="/account/login"><b>Log
                            In</b></a></p>
                    </div> <!-- end col-->
                </div>
                <!-- end row -->

            </div> <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</div>
<!-- end page -->

<footer class="footer footer-alt">
    2021 © Aivis - <span class="text-primary">Stay in the corner, control your world</span>
</footer>